const error = {
	email: 'Email is required',
	validEmail: 'Please Enter a valid email',
	fullName: 'First name is required',
	lname: 'Last name is required',
	telephone: 'Telephone Number is required',
	validNumber: 'Please Enter a valid Telephone number',
	validNumberLatitude: 'Must be valid latitude',
	validNumberLongitude: 'Must be valid longitude',
	maxLength: 'Must be 50 characters or less',
	invalidCharacters: 'Only letters, single quotes, hyphens and single spaces are allowed',
};
export default error;
